import {Component, OnInit} from '@angular/core';
import { RouterModule } from '@angular/router';
import {MatIconRegistry} from "@angular/material/icon";

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'tpl-dashboard';
  ngOnInit(): void {
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
  }
  constructor(private matIconReg: MatIconRegistry) {}
}
